import type {
  LpBlock,
  LpPage,
  LpPreviewMeta,
  LpPreviewPerformance,
  LpStat,
  LpTestingDetail,
} from './types';

export const LP_PAGES: LpPage[] = [
  {
    id: 'emergency-weekend',
    slug: 'emergency-weekend',
    preset: 'code_red',
    status: 'pending_approval',
    title: 'Weekend Emergency Dentist',
    url: 'go.smilecentral.com/emergency-weekend',
    campaign: { name: 'Weekend Emergency', budget: 1200 },
    blocks: 6,
    confidence: 94,
    created: '12 min ago',
    performance: null,
    testing: null,
  },
  {
    id: 'pediatric-back-to-school',
    slug: 'pediatric-back-to-school',
    preset: 'family',
    status: 'pending_approval',
    title: "Kids' Dental — Back to School",
    url: 'go.smilecentral.com/pediatric-back-to-school',
    campaign: { name: 'Pediatric Dentistry', budget: 900 },
    blocks: 7,
    confidence: 88,
    created: '3h ago',
    performance: null,
    testing: null,
  },
  {
    id: 'implants-nyc',
    slug: 'implants-nyc',
    preset: 'high_ticket',
    status: 'live',
    title: 'Dental Implants in NYC',
    url: 'go.smilecentral.com/implants-nyc',
    campaign: { name: 'Dental Implants NYC', budget: 3000 },
    blocks: 9,
    confidence: 96,
    created: '2 months ago',
    performance: { visits: 2847, conversions: 184, conversionRate: 6.5, formFills: 98, calls: 86 },
    testing: { phase: 'exploitation', totalVariants: 4, activeVariants: 1, leader: 'B', budgetSpent: 62 },
  },
  {
    id: 'invisalign-comparison',
    slug: 'invisalign-comparison',
    preset: 'transactional',
    status: 'live',
    title: 'Invisalign in Manhattan',
    url: 'go.smilecentral.com/invisalign-comparison',
    campaign: { name: 'Invisalign Spring', budget: 1800 },
    blocks: 7,
    confidence: 92,
    created: '6 weeks ago',
    performance: { visits: 1620, conversions: 71, conversionRate: 4.4, formFills: 48, calls: 23 },
    testing: { phase: 'validation', totalVariants: 4, activeVariants: 2, leader: 'A', budgetSpent: 38 },
  },
  {
    id: 'emergency-weekday',
    slug: 'emergency-weekday',
    preset: 'code_red',
    status: 'live',
    title: '24-Hour Emergency Dentist',
    url: 'go.smilecentral.com/emergency-weekday',
    campaign: { name: 'Emergency Weekday', budget: 2400 },
    blocks: 5,
    confidence: 97,
    created: '4 months ago',
    performance: { visits: 4180, conversions: 412, conversionRate: 9.9, formFills: 87, calls: 325 },
    testing: {
      phase: 'converged',
      totalVariants: 4,
      activeVariants: 1,
      leader: 'C',
      budgetSpent: 95,
      daysInExploitation: 38,
    },
  },
  {
    id: 'whitening-special-99',
    slug: 'whitening-special-99',
    preset: 'offer_funnel',
    status: 'live',
    title: '$99 Whitening Special',
    url: 'go.smilecentral.com/whitening-special-99',
    campaign: { name: 'Spring Whitening Promo', budget: 600 },
    blocks: 5,
    confidence: 91,
    created: '3 weeks ago',
    performance: { visits: 890, conversions: 68, conversionRate: 7.6, formFills: 52, calls: 16 },
    testing: { phase: 'exploration', totalVariants: 4, activeVariants: 4, leader: null, budgetSpent: 14 },
  },
  {
    id: 'sedation-dentist',
    slug: 'sedation-dentist',
    preset: 'anxiety',
    status: 'paused',
    title: 'Sedation Dentist Manhattan',
    url: 'go.smilecentral.com/sedation-dentist',
    campaign: { name: 'Sedation (paused)', budget: 0 },
    blocks: 7,
    confidence: 89,
    created: '2 months ago',
    performance: { visits: 1240, conversions: 38, conversionRate: 3.1, formFills: 28, calls: 10 },
    testing: { phase: 'exploitation', totalVariants: 4, activeVariants: 1, leader: 'A', budgetSpent: 82 },
    pausedReason: 'Parent campaign paused — budget reallocated to Weekend Emergency',
  },
];

export const LP_ARCHIVED_COUNT = 23;

/** Headline summary tiles for the list hub. */
export const LP_STATS: LpStat[] = [
  { key: 'live', label: 'Live pages', value: '5', sub: 'Receiving traffic', tone: 'success' },
  { key: 'pending', label: 'Pending approval', value: '2', sub: 'Needs your review', tone: 'gold' },
  { key: 'testing', label: 'Actively testing', value: '2', suffix: '/5', sub: 'Exploring or validating variants', tone: 'info' },
  { key: 'cr', label: 'Overall conversion rate', value: '6.8%', sub: '583 conversions this month', tone: 'success' },
];

/* ── Preview / editor mock ──────────────────────────────── */

export const LP_PREVIEW_META: LpPreviewMeta = {
  title: 'Dental Implants in NYC',
  preset: 'High-Ticket Authority',
  status: 'live',
  url: 'go.smilecentral.com/implants-nyc',
  campaign: 'Dental Implants NYC',
  createdDays: 62,
};

export const LP_PREVIEW_PERFORMANCE: LpPreviewPerformance = {
  visits: 2847,
  conversions: 184,
  conversionRate: 6.5,
  formFills: 98,
  calls: 86,
  bounceRate: 34,
  avgTimeSec: 142,
};

export const LP_BLOCKS: LpBlock[] = [
  {
    id: 'header',
    type: 'Global Header & Nav',
    variant: 'Standard',
    fields: [
      { key: 'logoText', label: 'Logo Text', value: 'Smile Central Dental', type: 'text' },
      {
        key: 'phoneNumber',
        label: 'Phone Number',
        value: '(212) 555-0129',
        type: 'text',
        note: 'Auto-tracked number from ELVA pool',
      },
      { key: 'ctaLabel', label: 'Book Online CTA', value: 'Book Consultation', type: 'text' },
      { key: 'stickyCTA', label: 'Sticky CTA on scroll', value: true, type: 'boolean' },
    ],
  },
  {
    id: 'hero',
    type: 'Authority Hero',
    variant: 'Consultative',
    fields: [
      {
        key: 'headline',
        label: 'Headline',
        value: 'Dental Implants in NYC — Same-Day Possible',
        type: 'text',
        maxLen: 60,
        variesAcrossVariants: true,
      },
      {
        key: 'subhead',
        label: 'Subheadline',
        value:
          "Restore your smile with expert, same-day implant solutions — led by NYC's most trusted implant specialists.",
        type: 'textarea',
        maxLen: 180,
        variesAcrossVariants: true,
      },
      {
        key: 'primaryCTA',
        label: 'Primary CTA',
        value: 'Book Free Consultation',
        type: 'text',
        maxLen: 28,
        variesAcrossVariants: true,
      },
      { key: 'secondaryCTA', label: 'Secondary CTA', value: 'See Results Gallery', type: 'text', maxLen: 28 },
      {
        key: 'heroImage',
        label: 'Background Image',
        value: 'Professional dental patient smiling',
        type: 'select',
        options: ['Professional dental patient smiling', 'Modern operatory shot', 'Doctor consultation'],
      },
    ],
  },
  {
    id: 'trust',
    type: 'Trust Strip',
    variant: 'Clinical Badges',
    fields: [
      { key: 'showADA', label: 'Show ADA Badge', value: true, type: 'boolean' },
      { key: 'showInvisalign', label: 'Show Invisalign Provider', value: true, type: 'boolean' },
      { key: 'showStraumann', label: 'Show Straumann Partner', value: true, type: 'boolean' },
      { key: 'yearsPracticing', label: 'Years Practicing', value: '18+ years', type: 'text' },
    ],
  },
  {
    id: 'transform',
    type: 'Clinical Transformation',
    variant: 'Interactive Slider',
    fields: [
      { key: 'caseCount', label: 'Number of Cases', value: 6, type: 'number' },
      {
        key: 'caseFilter',
        label: 'Filter Cases By',
        value: 'implant',
        type: 'select',
        options: ['implant', 'veneer', 'all cosmetic', 'recent only'],
      },
      {
        key: 'note',
        label: 'Consent gate',
        value: 'ELVA verifies media_release_signed for each case. 6 of 12 cases eligible.',
        type: 'info',
      },
    ],
  },
  {
    id: 'doctor',
    type: 'Doctor Bio',
    variant: 'Clinical Authority',
    fields: [
      { key: 'doctorName', label: 'Doctor Name', value: 'Dr. Maria Martinez, DDS', type: 'text' },
      { key: 'credentials', label: 'Credentials', value: 'AAID · ICOI · Straumann Certified', type: 'text' },
      { key: 'yearsExp', label: 'Years Experience', value: 18, type: 'number' },
      { key: 'implantCount', label: 'Implants Placed', value: '3,500+', type: 'text' },
      {
        key: 'bio',
        label: 'Bio Paragraph',
        value:
          'Dr. Martinez has placed over 3,500 implants across her 18-year career, specializing in complex cases including All-on-4 and full-arch reconstruction.',
        type: 'textarea',
        maxLen: 300,
      },
    ],
  },
  {
    id: 'financing',
    type: 'Financing Calculator',
    variant: 'Interactive Slider',
    fields: [
      { key: 'startPrice', label: 'Starting Price', value: 3200, type: 'number' },
      { key: 'endPrice', label: 'High-end Price', value: 25000, type: 'number' },
      { key: 'showCareCredit', label: 'Show CareCredit', value: true, type: 'boolean' },
      { key: 'showCherry', label: 'Show Cherry', value: true, type: 'boolean' },
      { key: 'showInHouse', label: 'Show In-House Financing', value: true, type: 'boolean' },
    ],
  },
  {
    id: 'faq',
    type: 'Dynamic FAQ',
    variant: 'Cost/Insurance Focused',
    fields: [
      { key: 'questionCount', label: 'Number of Questions', value: 6, type: 'number' },
      {
        key: 'autoGenerate',
        label: 'Auto-generate from campaign',
        value: true,
        type: 'boolean',
        note: 'ELVA generates FAQs based on search keywords driving traffic',
      },
      {
        key: 'topics',
        label: 'Priority Topics',
        value: 'cost, insurance, pain, timeline, recovery, alternatives',
        type: 'text',
      },
    ],
  },
  {
    id: 'booking',
    type: 'Booking Widget',
    variant: 'New Patient Triage',
    fields: [
      {
        key: 'primaryCTA',
        label: 'Form Button',
        value: 'Request Consultation',
        type: 'text',
        variesAcrossVariants: true,
      },
      { key: 'showInsuranceDropdown', label: 'Show Insurance Dropdown', value: true, type: 'boolean' },
      { key: 'autoFillPMS', label: 'Auto-fill from PMS', value: true, type: 'boolean' },
      {
        key: 'triggerAICall',
        label: 'Connect to AI Receptionist',
        value: true,
        type: 'boolean',
        note: 'AI receptionist may call after form submit',
      },
    ],
  },
  {
    id: 'footer',
    type: 'Compliance & Legal Footer',
    variant: 'Standard',
    fields: [
      { key: 'showNAP', label: 'Show NAP Block', value: true, type: 'boolean' },
      {
        key: 'complianceText',
        label: 'Compliance Disclaimer',
        value: 'Results may vary. Not a guarantee of outcomes.',
        type: 'textarea',
      },
    ],
  },
];

/** Catalog of addable blocks for create mode — empty values, user fills in. */
export const LP_BLOCK_CATALOG: Omit<LpBlock, 'id'>[] = LP_BLOCKS.map((block) => ({
  type: block.type,
  variant: block.variant,
  fields: block.fields.map((field) => {
    let value: string | number | boolean = '';
    if (field.type === 'number') value = 0;
    else if (field.type === 'boolean') value = false;
    else if (field.type === 'select') value = field.options?.[0] ?? '';
    else if (field.type === 'info') value = field.value;
    else value = '';
    const next: typeof field = {
      key: field.key,
      label: field.label,
      value,
      type: field.type,
    };
    if (field.note) next.note = field.note;
    if (field.maxLen != null) next.maxLen = field.maxLen;
    if (field.options) next.options = [...field.options];
    if (field.variesAcrossVariants != null) next.variesAcrossVariants = field.variesAcrossVariants;
    return next;
  }),
}));

export function createLpBlockFromCatalog(type: string, existingIds: string[] = []): LpBlock | null {
  const template = LP_BLOCK_CATALOG.find((block) => block.type === type);
  if (!template) return null;
  const baseId = type
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
  let id = baseId || 'block';
  let n = 2;
  while (existingIds.includes(id)) {
    id = `${baseId}-${n}`;
    n += 1;
  }
  return {
    id,
    type: template.type,
    variant: template.variant,
    fields: template.fields.map((field) => ({
      ...field,
      ...(field.options ? { options: [...field.options] } : {}),
    })),
  };
}

/** Create-mode shell for /landing-pages/new — starts with zero blocks. */
export const LP_CREATE_META: LpPreviewMeta = {
  title: 'New Landing Page',
  preset: 'transactional',
  status: 'pending_approval',
  url: '—',
  campaign: '—',
  createdDays: 0,
};

export const LP_CREATE_PERFORMANCE: LpPreviewPerformance = {
  visits: 0,
  conversions: 0,
  conversionRate: 0,
  formFills: 0,
  calls: 0,
  bounceRate: 0,
  avgTimeSec: 0,
};

export const LP_CREATE_TESTING: LpTestingDetail = {
  phase: 'exploration',
  totalVariants: 0,
  activeVariants: 0,
  budgetSpent: 0,
  currentRoundStarted: '—',
  nextRefreshIn: '—',
  winner: '—',
  variants: [],
};

export const LP_TESTING: LpTestingDetail = {
  phase: 'exploitation',
  totalVariants: 4,
  activeVariants: 1,
  budgetSpent: 62,
  currentRoundStarted: '42 days ago',
  nextRefreshIn: '48 days',
  winner: 'B',
  variants: [
    {
      id: 'A',
      label: 'Variant A',
      status: 'retired',
      isOriginal: true,
      isWinner: false,
      strategy: 'Control (original ELVA composition)',
      headline: 'Premium Dental Implants in NYC',
      cta: 'Book Free Consultation',
      visits: 920,
      conversions: 54,
      cr: 5.87,
    },
    {
      id: 'B',
      label: 'Variant B',
      status: 'active',
      isOriginal: false,
      isWinner: true,
      strategy: 'Specificity-led (concrete numbers)',
      headline: 'Dental Implants in NYC — Same-Day Possible',
      cta: 'Book Free Consultation',
      visits: 965,
      conversions: 70,
      cr: 7.25,
    },
    {
      id: 'C',
      label: 'Variant C',
      status: 'retired',
      isOriginal: false,
      isWinner: false,
      strategy: 'Outcome-focused (emotional)',
      headline: 'Get Your Confidence Back — Dental Implants NYC',
      cta: 'Start Your Journey',
      visits: 962,
      conversions: 46,
      cr: 4.78,
    },
    {
      id: 'D',
      label: 'Variant D',
      status: 'retired',
      isOriginal: false,
      isWinner: false,
      strategy: 'Urgency-led (scarcity)',
      headline: 'Free Implant Consultations — This Month Only',
      cta: 'Claim Your Slot',
      visits: 0,
      conversions: 0,
      cr: 0,
      note: 'Eliminated early by decisive-winner shortcut',
    },
  ],
};
